"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelector = void 0;
const react_1 = require("react");
const ssr_redux_context_1 = require("../context/ssr-redux-context");
const useSelector = (getter) => {
    const context = (0, react_1.useContext)(ssr_redux_context_1.SSRReduxContext);
    if (context === null) {
        throw new Error('You have to wrap component with SSRReduxContext');
    }
    const [get] = (0, react_1.useState)(() => getter);
    const [value, setValue] = (0, react_1.useState)(get(context.getState()));
    (0, react_1.useEffect)(() => context.subscribe(() => setValue(get(context.getState()))), [context, get]);
    return value;
};
exports.useSelector = useSelector;
//# sourceMappingURL=use-selector.js.map